export function upravIframe() {
  $("body").addClass("bdIframe");
}
